var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":null,"title":_vm.$t('sale.transfer-to-other')}}),_c('List',{attrs:{"dataList":_vm.saleTransferData,"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'sell_price', type: 'currency', sign: '$'}, {name: 'status', color: true}, {name: 'for_date', type: 'date'}],"fields":[ ("for_date: " + (_vm.$t('property.cancelation.date'))),
        ("sale: " + (_vm.$t('sale.text'))), 
        ("property: " + (_vm.$t('property.text'))), 
        ("from_name: " + (_vm.$t('sale.transfer.from-customer'))), 
        ("to_name: " + (_vm.$t('sale.transfer.to-customer'))), 
        ("sell_price: " + (_vm.$t('sale.sale-price'))),
        ("reason: " + (_vm.$t('property.cancelation.notation'))),
        ("status: " + (_vm.$t('property.status')))
      ],"more":{
        sub: [{
          name: 'property.cancelation.approve', icon: 'bx bx-check-circle', action: 'approve', link: 'commission-paid', column: 'id', show: {column: 'sale_transfer_status_id', value: 1}
        },{
          name: 'property.cancelation.denie', icon: 'bx bx-x-circle', action: 'denie', link: 'commission-paid', column: 'id', show: {column: 'sale_transfer_status_id', value: 1}
        },{
          name: 'general.print', icon: 'bx bx-file', link: 'report-transfer-sale-print', column: 'id', target: '_blank'
        }] 
      },"filter":{}},on:{"more":_vm.moreSaleTransferClicked}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }